// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pull-right[data-v-5768e374]{float:right;text-align:right}.ivu-form-item[data-v-5768e374]{margin-bottom:5px!important}", ""]);
// Exports
module.exports = exports;
